import React from "react";
import {
    Box,
    Button,
    Checkbox,
    Flex,
    Grid,
    IconButton,
    Tag,
    Text,
    Tooltip,
} from "@chakra-ui/react";
import { formatDate, formatDateTime } from "utils/dateUtils/dateUtils";
import { IoImage } from "react-icons/io5";
import { EditIcon } from "@chakra-ui/icons";

interface CardProps {
    data: any[];
    setSelectedAdPath: (value: React.SetStateAction<string>) => void;
    setIsImageModalOpen: (value: React.SetStateAction<boolean>) => void;
    handleEdit: any;
}

export default function AdCard({
    data,
    setSelectedAdPath,
    setIsImageModalOpen,
    handleEdit
}: CardProps) {
    return (
        <>
            <Grid templateColumns="1fr" gap={4}>
                {data?.map((ad: any) => {
                    return (
                        <Box
                            key={ad._id}
                            p={4}
                            shadow="base"
                            borderRadius="lg"
                            bg="white"
                        >
                            <Flex justify="space-between" mb={2}>
                                <Text
                                    fontWeight="bold"
                                    color="teal.500"
                                    isTruncated={true}
                                    w={"10rem"}
                                >
                                    Name: {ad?.name}
                                </Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text isTruncated maxW={"70vw"} >
                                    Redirect Url:{" "}
                                    {ad?.redirect_url}
                                </Text>
                            </Flex>

                            <Flex justify="start" align={'center'} gap={2} mb={2}>
                                {/* <Text>
                                    Is Active: {" "}
                                </Text> */}
                                <Tag
                                    size="sm"
                                    colorScheme={ad.is_active ? "green" : "red"}
                                >
                                    {ad.is_active ? "Active" : "Inactive"}
                                </Tag>
                            </Flex>

                            <Flex justify="start" gap={2} mb={2}>
                                <IconButton
                                    size={"sm"}
                                    colorScheme="teal"
                                    variant={"outline"}
                                    aria-label="Image"
                                    icon={<IoImage />}
                                    onClick={() => {
                                        setSelectedAdPath(ad.path);
                                        setIsImageModalOpen(true);
                                    }}
                                />
                                <Tooltip label="Edit" hasArrow>
                                    <IconButton
                                        size={"sm"}
                                        colorScheme="teal"
                                        variant={"outline"}
                                        aria-label="Edit"
                                        icon={<EditIcon />}
                                        onClick={() => handleEdit(ad)}
                                    />
                                </Tooltip>
                            </Flex>
                            {/* <Flex justify="space-between" mb={2}>
                                <Tooltip label="Edit" hasArrow>
                                    <IconButton
                                        size={"sm"}
                                        colorScheme="teal"
                                        variant={"outline"}
                                        aria-label="Edit"
                                        icon={<EditIcon />}
                                        onClick={() => handleEdit(ad)}
                                    />
                                </Tooltip>
                            </Flex> */}
                        </Box>
                    );
                })}
            </Grid>
        </>
    );
}
